var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCleaning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 89,
    viewBox: "0 0 166 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1002_9032)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5031 52.8593C41.024 52.8593 39.8249 54.0583 39.8249 55.5375V66.0273C39.8249 67.5065 41.024 68.7056 42.5031 68.7056H59.9118C61.3909 68.7056 62.59 67.5065 62.59 66.0273V55.5375C62.59 54.0583 61.3909 52.8593 59.9118 52.8593H42.5031ZM45.3249 58.3593V63.2056H57.09V58.3593H45.3249Z",
    fill: "url(#paint0_linear_1002_9032)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6572 36.2869C42.8449 37.4239 40.0655 38.5476 37.6487 40.455C32.3036 44.1111 29.3333 51.3249 29.3333 57.5977V68.2878C29.3333 75.6678 35.316 81.6505 42.696 81.6505H59.6221C67.0021 81.6505 72.9848 75.6678 72.9848 68.2878C72.9848 61.3403 72.9571 54.3929 72.9293 47.4455C72.9006 40.2695 72.8719 33.0935 72.8739 25.9174C72.8763 16.812 66.0931 9.13382 57.0567 8.01287C56.9374 7.99806 56.8198 7.99494 56.7049 8.00251C56.6582 7.99987 56.6113 7.99854 56.564 7.99854H42.5031C41.024 7.99854 39.8249 9.19763 39.8249 10.6768V13.5782C39.8249 16.4332 41.9691 18.7874 44.735 19.1182V26.5231C44.735 28.0023 45.9341 29.2014 47.4132 29.2014C48.8924 29.2014 50.0915 28.0023 50.0915 26.5231V19.1579H53.6625C54.3199 19.1579 54.899 19.1332 55.4089 19.0856C55.1353 25.6812 53.2142 33.2136 46.3999 35.986C46.1524 36.0867 45.9044 36.187 45.6572 36.2869ZM40.7538 44.9946L40.9087 44.8887L41.056 44.7724C42.831 43.3716 44.9 42.5314 47.9184 41.3057L48.4726 41.0805C56.2393 37.9206 59.2342 30.724 60.3149 24.786C60.9418 21.3416 61.023 17.8776 60.8913 14.9323C64.7872 17.082 67.3751 21.2267 67.3738 25.916C67.372 32.9912 67.3997 40.0644 67.428 47.1245L67.4293 47.4641C67.4571 54.4144 67.4848 61.3519 67.4848 68.2878C67.4848 72.6303 63.9646 76.1505 59.6221 76.1505H42.696C38.3536 76.1505 34.8333 72.6303 34.8333 68.2878V57.5977C34.8333 52.6927 37.2428 47.3962 40.7538 44.9946Z",
    fill: "url(#paint1_linear_1002_9032)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2965 11.9614C27.4262 11.5665 27.9152 11.5665 28.0448 11.9614L29.1555 15.3446C30.0576 18.0924 32.179 20.2962 34.93 21.3437C35.2943 21.4824 35.2943 22.0711 34.93 22.2098C32.1789 23.2573 30.0576 25.4611 29.1555 28.2089L28.0448 31.592C27.9152 31.9869 27.4262 31.9869 27.2965 31.592L26.1767 28.181C25.2788 25.446 23.1673 23.2524 20.4291 22.2098C20.0647 22.0711 20.0647 21.4824 20.4291 21.3437C23.1673 20.3011 25.2788 18.1075 26.1766 15.3725L27.2965 11.9614Z",
    fill: "url(#paint2_linear_1002_9032)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3555 34.1215C16.4528 33.8253 16.8195 33.8253 16.9168 34.1215L17.7498 36.6589C18.4263 38.7197 20.0173 40.3726 22.0806 41.1583C22.3539 41.2623 22.3539 41.7038 22.0806 41.8078C20.0173 42.5934 18.4263 44.2463 17.7497 46.3072L16.9168 48.8445C16.8195 49.1407 16.4528 49.1407 16.3555 48.8445L15.5157 46.2862C14.8422 44.235 13.2586 42.5898 11.2049 41.8078C10.9317 41.7038 10.9317 41.2623 11.2049 41.1583C13.2586 40.3763 14.8422 38.7311 15.5156 36.6799L16.3555 34.1215Z",
    fill: "url(#paint3_linear_1002_9032)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1002_9032)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.291 49.5404C106.592 50.3246 107.01 52.0147 106.226 53.3154L90.439 79.501C89.6548 80.8017 87.9647 81.2204 86.664 80.4362C85.3633 79.652 84.9446 77.9619 85.7288 76.6613L101.516 50.4757C102.3 49.175 103.99 48.7563 105.291 49.5404Z",
    fill: "url(#paint4_linear_1002_9032)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.261 38.1763C102.055 36.8814 103.748 36.4751 105.043 37.2688L116.437 44.2522C117.731 45.0459 118.138 46.739 117.344 48.0339L115.598 50.8823C112.876 55.3234 107.069 56.717 102.628 53.9949C98.187 51.2728 96.7934 45.4658 99.5155 41.0247L101.261 38.1763ZM104.514 43.3951L104.205 43.8989C103.07 45.7502 103.651 48.1709 105.502 49.3056C107.354 50.4404 109.774 49.8594 110.909 48.0081L111.218 47.5044L104.514 43.3951Z",
    fill: "url(#paint5_linear_1002_9032)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.437 13.2125C108.494 21.2608 108.97 30.0484 106.82 38.3587L114.65 43.1581C121.084 37.474 129.133 33.9119 137.693 32.9834C135.345 28.0215 130.286 22.9462 124.014 19.1022C117.743 15.2582 110.924 13.0533 105.437 13.2125ZM114.994 46.5941L116.919 48.5577C122.832 42.7601 130.559 39.1732 138.804 38.399L141.719 38.1253C142.513 38.0507 143.235 37.6355 143.699 36.987C144.162 36.3386 144.322 35.5208 144.136 34.7456C142.235 26.8234 134.989 19.3779 126.888 14.4129C118.788 9.44798 108.865 6.37019 100.943 8.27135C100.168 8.45738 99.5114 8.97065 99.144 9.67815C98.7766 10.3857 98.7344 11.2178 99.0281 11.9589L100.108 14.6831C103.152 22.3612 103.464 30.8514 100.995 38.7317C100.592 39.9208 101.048 41.2721 102.164 41.9558L113.557 48.9387L114.994 46.5941Z",
    fill: "url(#paint6_linear_1002_9032)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.843 26.5772C131.573 25.7628 132.839 25.4636 133.584 25.4571L133.536 19.9573C131.654 19.9738 129.556 20.6335 127.501 21.6007C125.397 22.591 123.125 24.005 120.842 25.7572C116.28 29.2591 111.512 34.2376 107.83 40.2437L112.519 43.1179C115.822 37.7306 120.119 33.2452 124.191 30.1201C126.225 28.5589 128.161 27.3685 129.843 26.5772Z",
    fill: "url(#paint7_linear_1002_9032)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.709 17.3005C114.649 15.3888 114.342 14.1257 114.009 13.4587L118.932 11.0056C119.771 12.6894 120.135 14.8585 120.206 17.1289C120.279 19.4536 120.05 22.1198 119.525 24.9491C118.474 30.6036 116.201 37.1118 112.519 43.1179L107.83 40.2437C111.132 34.8564 113.18 28.991 114.117 23.9449C114.585 21.4239 114.767 19.158 114.709 17.3005Z",
    fill: "url(#paint8_linear_1002_9032)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.688 43.5915C132.591 43.2953 132.224 43.2953 132.127 43.5915L131.287 46.1498C130.613 48.201 129.03 49.8462 126.976 50.6282C126.703 50.7322 126.703 51.1737 126.976 51.2777C129.03 52.0597 130.613 53.7049 131.287 55.7561L132.127 58.3144C132.224 58.6106 132.591 58.6106 132.688 58.3144L133.521 55.7771C134.197 53.7163 135.788 52.0634 137.852 51.2777C138.125 51.1737 138.125 50.7322 137.852 50.6282C135.788 49.8426 134.197 48.1897 133.521 46.1289L132.688 43.5915Z",
    fill: "url(#paint9_linear_1002_9032)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.688 10.5914C154.591 10.2952 154.224 10.2952 154.127 10.5914L153.287 13.1498C152.613 15.201 151.03 16.8462 148.976 17.6282C148.703 17.7322 148.703 18.1737 148.976 18.2777C151.03 19.0597 152.613 20.7049 153.287 22.7561L154.127 25.3144C154.224 25.6106 154.591 25.6106 154.688 25.3144L155.521 22.7771C156.197 20.7162 157.788 19.0633 159.852 18.2777C160.125 18.1737 160.125 17.7322 159.852 17.6282C157.788 16.8426 156.197 15.1897 155.521 13.1288L154.688 10.5914Z",
    fill: "url(#paint10_linear_1002_9032)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.413 51.4717C149.286 51.1137 148.81 51.1137 148.683 51.4717L147.592 54.5641C146.717 57.0435 144.659 59.0321 141.99 59.9773C141.635 60.1031 141.635 60.6367 141.99 60.7625C144.659 61.7076 146.717 63.6963 147.592 66.1757L148.683 69.268C148.81 69.626 149.286 69.626 149.413 69.268L150.495 66.2011C151.374 63.71 153.442 61.7121 156.124 60.7625C156.479 60.6367 156.479 60.1031 156.124 59.9773C153.442 59.0277 151.375 57.0298 150.495 54.5388L149.413 51.4717Z",
    fill: "url(#paint11_linear_1002_9032)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1002_9032",
    x1: 11,
    y1: 81.6504,
    x2: 77.5264,
    y2: 77.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1002_9032",
    x1: 11,
    y1: 81.6504,
    x2: 77.5264,
    y2: 77.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1002_9032",
    x1: 11,
    y1: 81.6504,
    x2: 77.5264,
    y2: 77.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1002_9032",
    x1: 11,
    y1: 81.6504,
    x2: 77.5264,
    y2: 77.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1002_9032",
    x1: 160.057,
    y1: 7.70336,
    x2: 80.0209,
    y2: 14.0725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1002_9032",
    x1: 160.057,
    y1: 7.70336,
    x2: 80.0209,
    y2: 14.0725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1002_9032",
    x1: 160.057,
    y1: 7.70336,
    x2: 80.0209,
    y2: 14.0725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1002_9032",
    x1: 160.057,
    y1: 7.70336,
    x2: 80.0209,
    y2: 14.0725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1002_9032",
    x1: 160.057,
    y1: 7.70336,
    x2: 80.0209,
    y2: 14.0725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1002_9032",
    x1: 160.057,
    y1: 7.70336,
    x2: 80.0209,
    y2: 14.0725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1002_9032",
    x1: 160.057,
    y1: 7.70336,
    x2: 80.0209,
    y2: 14.0725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1002_9032",
    x1: 160.057,
    y1: 7.70336,
    x2: 80.0209,
    y2: 14.0725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_9032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white",
    transform: "translate(0 0.665039)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1002_9032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white",
    transform: "translate(78 0.665039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleaning);
export default __webpack_public_path__ + "static/media/Cleaning.e3ac5fd68fe3427c914b3983c43c9c35.svg";
export { ForwardRef as ReactComponent };